<template>
  <div :class="{'page-bottom': is_fixed}" style="margin-top:3vw">
    <div class='home_content'>
      <!-- <div class='home_title'>
        <img src="../assets/home/home_title_icon.png"  class='home-title-icon'>
        <p>{{$t('home.join_we')}}</p>
      </div> -->
      <div class="msg_content">
        <el-image v-if="$i18n.locale==='zh'" :src="join_bottom" style=" width: 100%; margin-bottom: 3%"></el-image>
        <el-image v-else-if="$i18n.locale==='en'" :src="join_bottom_en" style=" width: 100%; margin-bottom: 3%"></el-image>
      </div>
    </div>
    <div id="bottom">
      <el-image v-if="$i18n.locale==='zh'" :src="src" class="bottom-img"></el-image>
      <el-image v-else-if="$i18n.locale==='en'" :src="src_en" class="bottom-img"></el-image>

    </div>

  </div>

</template>


<script>
export default {
  data() {
    return {
      src: `${require('../assets/common/footer_logo.png')}`,
      src_en: `${require('../assets/common/footer_logo.png')}`,
      input: ''
    };
  },
  computed: {
    //英文版首页、关于页，内容不足
    is_fixed() {
      const cur_path = this.$route.path.split('/')[1];
      return false;
      // return cur_path === '' && this.$i18n.locale === 'en' ? true : false
    },
    join_bottom() {
      return `${require('../assets/common/footer_join.png')}`
    },
    join_bottom_en() {
      return `${require('../assets/common/footer_join.png')}`
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../assets/style/colors.less');
.beian {
  font-size: 1.2vw;
  color: white;
  padding-bottom: 20px;
  font-family: auto;
  cursor: pointer;
  a {
    text-decoration:none;
    color: #828181;
  }
}
#bottom {
  width: 100%;
  margin: 4vw 0 0 0;
  padding: 2vw 0 1vw;
  background: #1f4006;
  position: relative;
}
.bottom-img {
  width: 70%
}
.msg_content {
  width: 100%;
  // padding: 2.5vw 2.2vw;
  // background: @lanmu;
  position: relative;
  overflow: hidden;
  .msg {
    width: 24vw;
    height: 3.5vw;
    margin-top: 1vw;
    background: white;
    display: flex;
    float: right;
    align-items: center;
    overflow: hidden;
    .msg-input {
      position: relative;
      width: 79%;
      float: left;
    }
    .msg-icon {
      float: right;
      margin-right: 1px;
    }
  }
  .msg_content_intro {
    position: relative;
    float: left;
    width: 50%;
    .msg-text {
      width: 70%;
    }
  }
}
.msg-input {
  display: block;
}
.msg-input-mobile {
  display: none;
}
.over {
  overflow:hidden;
}
.msg-icon-img {
  height: 3vw;
  margin-top: 5px;
}
.res-class {
 position: absolute;
  left: 27%;
}

@media screen and (max-width: 992px) {
  .res-class {
    left: 0%;
    position: relative;
  }
  .beian {
    font-size: 12px;
    padding-bottom:2px;
  }
  .home_title p {
    bottom: 2.3vw;
  }
  .home-title-icon {
    height: 6.5vw;
  }
  .msg_content {
    .msg {
      width: 50%;
      height: 5.5vw;
      margin-top: -1vw;
      margin-top: 3vw;
    }
    .msg_content_intro {
      width: 45%;
      .msg-text {
        width: 85%;
      }
    }
  }
  .msg-input {
    display: none;
  }
  .msg-input-mobile {
    display: block;
  }
  .msg-icon-img {
    height: 5vw;
  }
  .bottom-img {
    width: 90%
  }
  .page-bottom {
    bottom: 0;
    margin-top: 3vw;
    position: fixed;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Bottom.vue